import { shopifyOrdersByNamesAdminUrl } from '../utils/shopifyAdmin';
import { getPreorderItemSkuKey } from './PreordersModal.helpers';

export function preorderStore(order) {
  const value = String(order?.storeOverride || '').toLowerCase().replace(/[^a-z]/g, '');
  if (value) return value === 'ccc' || value === 'centralcoastcoffee' ? 'ccc' : 'phaser';
  return String(order?.orderNumber || '').trim().replace(/^#/, '').toUpperCase().startsWith('CCC') ? 'ccc' : 'phaser';
}

export function poPreorderStore(po) {
  const value = String(po?.storeKey || po?.store || '').toLowerCase().replace(/[^a-z]/g, '');
  if (value === 'ccc' || value === 'centralcoastcoffee') return 'ccc';
  if (value === 'phaser' || value === 'phaserfpv') return 'phaser';
  return null;
}

export function preorderBadgeKey(po, sku) {
  return `${poPreorderStore(po)}:${String(sku || '').trim().toUpperCase()}`;
}

export function preorderShopifyUrl(order, store) {
  if (!order) return undefined;
  const handle = store || (preorderStore(order) === 'ccc' ? 'central-coast-coffee' : 'phaser-fpv');
  const raw = String(order.orderId || '').trim();
  const id = raw.match(/^(?:gid:\/\/shopify\/Order\/)?([1-9]\d*)$/)?.[1];
  if (id) return `https://admin.shopify.com/store/${handle}/orders/${id}`;
  return shopifyOrdersByNamesAdminUrl(handle, [order.orderNumber]) || undefined;
}

export function filterPreordersByRelatedPo(orders, po, archivedLineKeys = []) {
  if (!po) return [];
  const store = poPreorderStore(po);
  if (!store) return [];
  const skus = new Set((po.items || []).map(item => String(item?.sku || '').trim().toUpperCase()).filter(Boolean));
  const archived = new Set(archivedLineKeys.map(key => String(key).trim().toUpperCase()));
  return orders.filter(order => preorderStore(order) === store).map(order => ({
    ...order,
    lineItems: (order.lineItems || []).filter(item => {
      const sku = String(getPreorderItemSkuKey(item) || '').trim().toUpperCase();
      const ids = [item.orderId, order.orderId || order.id, order.orderNumber].filter(Boolean);
      return skus.has(sku) && !ids.some(id => archived.has(`${id}__${sku}`.toUpperCase()));
    })
  })).filter(order => order.lineItems.length > 0);
}

// Use the same display list as Incoming Stock (including split/received lines and extras).
export async function fetchRelatedPreorderPo(client, apiUrl, id, config) {
  let page = 1;
  let totalPages = 1;
  do {
    const { data } = await client.get(`${apiUrl}/api/purchase-orders`, {
      ...config, params: { query: id, status_tab: 'all', include_items: true, stale_while_revalidate: true, limit: 200, page }
    });
    if (!Array.isArray(data?.purchase_orders)) throw new Error('Invalid purchase order response.');
    const po = data.purchase_orders.find(order => String(order.id) === String(id));
    if (po) {
      if (!poPreorderStore(po) || !Array.isArray(po.items)) throw new Error('Purchase order details are incomplete.');
      return po;
    }
    totalPages = Number(data.meta?.total_pages) || 1;
    page += 1;
  } while (page <= totalPages);
  throw new Error('Purchase order could not be found.');
}
